import React from 'react'
import { useDispatch } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import { logIn } from 'ducks/auth'
import { useControlledForm } from 'hooks'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

const useLoginMutations = () => {
  const dispatch = useDispatch()

  const handleLogIn = React.useCallback(
    ({ email, password }) => {
      dispatch(logIn(email, password))
    },
    [dispatch],
  )

  return { handleLogIn }
}

export const useLoginForm = () => {
  const defaultValues = getDefaultValues()
  const schema = getSchema()

  const { handleLogIn } = useLoginMutations()

  const handleFormData = React.useCallback(
    data => {
      handleLogIn({ ...data })
    },
    [handleLogIn],
  )

  const { control, formState, handleFormSubmit } = useControlledForm({
    defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  return {
    state: { control, formState },
    handlers: { handleFormSubmit },
  }
}
